import React, { useState, useCallback } from 'react';
import { Container } from 'react-bootstrap';
import apiRequests from './api-helpers/ApiRequests';
import { ReactComponent as ZmpgSvg } from '../svg/zmpg.svg';
import { useTranslation } from 'react-i18next';


export const ChangePasswordForm = () => {
    const [changePassword, setChangePassword] = useState({});
    const [isValidForm, setIsValidForm] = useState(true);
    const [errors, setErrors] = useState({});
    const { t } = useTranslation();

    const changePasswordCallback = useCallback((data, response) => {
        if (response.status === 400) {
            if (data.errors) {
                setErrors(data.errors);
                setIsValidForm(false);
            }
        } else if (response.status === 200) {
            setErrors({});
            if (data.Succeeded) {
                window.location.replace(window.location.origin);
            }
        }
    }, []);

    const onInputChange = useCallback((event) => {
        const { name, value } = event.target;

        setChangePassword(prev => {
            const updated = { ...prev, [name]: value };

            // Trigger validation if form was previously invalid
            if (!isValidForm) {
                apiRequests.getDataByUrlWithParam('user/ChangePasswordValidate', updated, changePasswordCallback);
            }

            return updated;
        });
    }, [isValidForm, changePasswordCallback]);

    const onFormSubmit = useCallback((event) => {
        event.preventDefault();
        apiRequests.getDataByUrlWithParam('user/ChangePassword', changePassword, changePasswordCallback);
    }, [changePassword, changePasswordCallback]);

    return (
        <Container>
            <div className="row">
                <div className="col-md-4" />
                <div className="col-md-4 mt-5 p-3 border rounded shadow-sm">
                    <form id="change-passwd-form" onSubmit={onFormSubmit}>
                        <div className="mt-2 text-center">
                            <ZmpgSvg />
                        </div>
                        <hr />
                        <div className="mb-3">
                            <label htmlFor="currentPassword" className="form-label">{t('account.currentPasswordLabel') }:</label>
                            <input
                                type="password"
                                className="form-control"
                                id="currentPassword"
                                name="CurrentPassword"
                                onChange={onInputChange}
                            />
                            <span className="text-danger">{errors.CurrentPassword?.[0] || ""}</span>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="newPassword" className="form-label">{t('account.newPasswordLabel')}:</label>
                            <input
                                type="password"
                                className="form-control"
                                id="newPassword"
                                name="NewPassword"
                                onChange={onInputChange}
                            />
                            <span className="text-danger">{errors.NewPassword?.[0] || ""}</span>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="confirmNewPassword" className="form-label">{t('account.confirmNewPasswordLabel')}:</label>
                            <input
                                type="password"
                                className="form-control"
                                id="confirmNewPassword"
                                name="ConfirmNewPassword"
                                onChange={onInputChange}
                            />
                            <span className="text-danger">{errors.ConfirmNewPassword?.[0] || ""}</span>
                        </div>
                        <div className="mb-3 form-group">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="acceptTerms"
                                    name="AcceptTerms"
                                    required
                                    onChange={onInputChange}
                                />
                                <label className="form-check-label" style={{ fontWeight: 400, fontSize: "14px", verticalAlign: "middle" }}>
                                    <span style={{ verticalAlign: "middle", color: "#707070" }}>{t('account.acceptTermsText')}    <a href="/pdf/Regulamin_SARP.pdf" target="_blank" rel="noopener noreferrer">{t('account.acceptTermsLink')}</a>.
                                    </span>
                                </label>
                            </div>
                        </div>

                        <button
                            form="change-passwd-form"
                            type="submit"
                            style={{ fontWeight: "500", fontSize: "16px" }}
                            className="btn btn-primary bg-primary btn-lg border w-100"
                        >
                            {t('account.formTitle')}
                        </button>
                    </form>
                </div>
                <div className="col-md-4" />
            </div>
        </Container>
    );
};
